import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const PlayerView = () => {
  const { flowId } = useParams();

  useEffect(() => {
    localStorage.setItem("flowId", `${flowId}`);
  }, [flowId]);

  useEffect(() => {
    if (!window.location.hash) {
      window.location.href = window.location.href + "#loaded";
      window.location.reload();
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography variant="h3" color="secondary" mb={3}>
          Dopple
        </Typography>
        <CircularProgress color="secondary" />
      </Box>
    </Box>
  );
};

export default PlayerView;
